import { z } from "zod";

export const ProductCostCurrencyItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  Symbol: z.string(),
  Precision: z.number(),
  ISOCode: z.string(),
});

export type ProductCostCurrencyItemType = z.infer<
  typeof ProductCostCurrencyItemSchema
>;
